import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useFreeTierQuery = createQueryHook(MembershipsCreatorApiClient.getFreeTier, {
  queryKey: ['freeTier'],
})
